import React, { useState, useEffect, useContext } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";

import "./modal.css";
import { FaArrowLeft } from "react-icons/fa";
import { MdSend, MdInbox, MdSync } from "react-icons/md";
import axios from "axios";
import { CircularProgress } from "@mui/material";
import { IoIosRefresh } from "react-icons/io";
import { GlobalVariablesContext } from "../GlobalVariables";
import toast from "react-hot-toast";

// Reverting to hardcoded data as requested
const emailData = [
  // ... (keep data same, assumed handled by tool context or separate edit if needed, but tool replaces contiguous block)
  // I will not replace the data block to avoid huge output, I will target above/below.
  // Wait, replace_file_content replaces the whole block. 
  // I should use multi_replace for surgical edits or targeted small chunks.

  { id: 1, name: "gopalayush04@gmail.com" },
  { id: 2, name: "support@ledshoe.in" },
  { id: 3, name: "kb@ledshoe.in" },
  { id: 4, name: "support@ledshoes.in" },
  { id: 5, name: "kr@ledshoes.in" },
  { id: 6, name: "privacy@ledshoes.in" },
  { id: 7, name: "partners@ledshoes.in" },
  { id: 8, name: "feedback@ledshoes.in" },
  { id: 9, name: "careers@ledshoes.in" },
  { id: 10, name: "admin@ledshoes.in" },
  { id: 11, name: "support@myledshoes.com" },
  { id: 12, name: "jack@myledshoes.com" },
  { id: 13, name: "careers@ledlightshoes.com" },
  { id: 14, name: "akshay@ledlightshoes.com" },
  { id: 15, name: "info@ledlightshoes.com" },
  { id: 16, name: "support@ledlightshoes.com" },
  { id: 17, name: "support@lightshoes.in" },
  { id: 18, name: "kr@lightshoes.in" },
  { id: 19, name: "support@lightshoe.in" },
  { id: 20, name: "rachit@lightshoe.in" },
  { id: 21, name: "support@amdesi.com" },
  { id: 22, name: "vn@amdesi.com" },
  { id: 23, name: "partners@amdesi.com" },
  { id: 24, name: "info@amdesi.com" },
  { id: 25, name: "support@amdesi.in" },
  { id: 26, name: "vn@amdesi.in" },
  { id: 27, name: "partners@amdesi.in" },
  { id: 28, name: "info@amdesi.in" },
  { id: 29, name: "support@onlineledshoes.com" },
  { id: 30, name: "gr@onlineledshoes.com" },
  { id: 31, name: "feedback@onlineledshoes.com" },
  { id: 32, name: "partners@onlineledshoes.com" },
  { id: 33, name: "support@onlineledshoe.com" },
  { id: 34, name: "gr@onlineledshoe.com" },
  { id: 35, name: "feedback@onlineledshoe.com" },
  { id: 36, name: "partners@onlineledshoe.com" },
  { id: 37, name: "support@lightingshoe.com" },
  { id: 38, name: "nikita@lightingshoe.com" },
  { id: 39, name: "partners@lightingshoe.com" },
  { id: 40, name: "info@lightingshoe.com" },
  { id: 41, name: "careers@lightingshoe.com" },
  { id: 42, name: "support@theledshoes.com" },
  { id: 43, name: "harry@theledshoes.com" },
  { id: 44, name: "partners@theledshoes.com" },
  { id: 45, name: "info@theledshoes.com" },
  { id: 46, name: "careers@theledshoes.com" },
  { id: 47, name: "support@theledshoe.com" },
  { id: 48, name: "rekha@theledshoe.com" },
  { id: 49, name: "partners@theledshoe.com" },
  { id: 50, name: "info@theledshoe.com" },
  { id: 51, name: "feedback@lightingshoe.com" },
  { id: 52, name: "careers@theledshoe.com" },
  { id: 53, name: "careers@shiningshoes.com" },
  { id: 54, name: "sen@shiningshoes.com" },
  { id: 55, name: "info@shiningshoes.com" },
  { id: 56, name: "support@shiningshoes.com" },
  { id: 57, name: "support@litfeet.com" },
  { id: 58, name: "sagar@litfeet.com" },
  { id: 59, name: "support@ledfeet.com" },
  { id: 60, name: "akash@ledfeet.com" },
  { id: 61, name: "support@lumishoes.com" },
  { id: 62, name: "lakshay@lumishoes.com" },
  { id: 63, name: "info@lumishoes.com" },
  { id: 64, name: "careers@lumishoes.com" },
  { id: 65, name: "support@lumoshoes.com" },
  { id: 66, name: "raj@lumoshoes.com" },
  { id: 67, name: "info@lumoshoes.com" },
  { id: 68, name: "careers@lumoshoes.com" },
  { id: 69, name: "support@flashsteps.com" },
  { id: 70, name: "kiran@flashsteps.com" }
];

let data_emails = [];

function Email_Select_Modal({
  slected_num,
  open,
  handleClose,
  handleSelectEmail,
  handleComposeEmail,
}) {
  const [selectedNumber, setSelectedNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [sortedEmails, setSortedEmails] = useState([]);
  const [timestampMap, setTimestampMap] = useState({});
  const [syncing, setSyncing] = useState(false);

  const fetchSortOrder = async () => {
    try {
      const res = await axios.get('https://casualfootwears.com/api/get_email_sort_order/');
      setTimestampMap(res.data);
    } catch (e) {
      console.error("Failed to fetch sort order", e);
    }
  };

  useEffect(() => {
    fetchSortOrder();
  }, []);

  const handleSync = async () => {
    if (syncing) return;
    setSyncing(true);
    toast.success("Sync started in background...");
    try {
      await axios.post('https://casualfootwears.com/api/manual_sync_timestamps/');
    } catch (e) {
      console.error(e);
    }

    // Refresh sort order after a delay (optimistic)
    setTimeout(() => {
      fetchSortOrder();
      setSyncing(false);
      toast.success("Sync likely complete. Refreshing list.");
    }, 5000);
  };

  // const { userData2 } = useContext(GlobalVariablesContext); // Disabled dynamic loading

  const handleLastMail = async () => {
    try {
      setLoading(true);

      const data = await axios.get(
        `${process.env.REACT_APP_LAST_USED_MAIL_GET_API}${slected_num}`
      );
      setSelectedNumber(data.data[slected_num]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleLastMail();
  }, [slected_num]);


  useEffect(() => {
    // Sort emails: Newest Timestamp first, then Alphabetical
    const sorted = [...emailData].sort((a, b) => {
      const tsA = timestampMap[a.name] || 0;
      const tsB = timestampMap[b.name] || 0;
      if (tsA !== tsB) {
        return tsB - tsA; // Descending
      }
      return a.name.localeCompare(b.name);
    });

    const selectedIndex = sorted.findIndex(email => email.name === selectedNumber);

    if (selectedIndex !== -1) {
      const selectedEmail = sorted.splice(selectedIndex, 1)[0]; // Remove selected email from its position
      sorted.unshift(selectedEmail); // Add selected email to the beginning of the array
    }

    setSortedEmails(sorted);
  }, [selectedNumber, timestampMap]);




  return (
    <Modal
      open={open}
      onClose={handleClose}
      center
      classNames={{ modal: "customModal" }}
    >

      <div
        className="modal-header"
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <FaArrowLeft
            style={{
              fontSize: "20px",
              cursor: "pointer",
            }}
            onClick={handleClose}
          />
          <h1 style={{ color: "#333" }}>Please Select Email</h1>
        </div>
        <div style={{ display: "flex", gap: "10px" }}>
          <button className="modal_btn" onClick={handleSync} disabled={syncing} style={{ opacity: syncing ? 0.7 : 1 }}>
            Sync <MdSync size={16} className={syncing ? "spin-animation" : ""} />
          </button>
          <button className="modal_btn" onClick={() => { handleLastMail(); fetchSortOrder(); }}>
            Refresh <IoIosRefresh size={16} />
          </button>
        </div>
      </div>

      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100px",
          }}
        >
          <CircularProgress color="primary" size={40} thickness={4} />
        </div>
      ) : (
        <div style={{ textAlign: "center", width: "100%" }}>
          <ul style={{ listStyle: "none", padding: 0 }}>
            {sortedEmails.map((email) => (
              <li
                style={{
                  backgroundColor:
                    selectedNumber === email.name
                      ? "#007bff"
                      : data_emails.includes(email.name)
                        ? "#e3f2fd"
                        : "#ffffff",
                  color: selectedNumber === email.name ? "white" : "#333",
                  padding: "12px 16px",
                  margin: "8px 0",
                  borderRadius: "8px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  border: "1px solid #eee",
                  transition: "all 0.2s ease"
                }}
                key={email.id}
                className="element-item"
              >
                <span style={{ fontWeight: "500", fontSize: "15px", overflow: "hidden", textOverflow: "ellipsis", marginRight: "10px", flex: 1, textAlign: "left" }}>
                  {email.name}
                </span>

                <div style={{ display: "flex", gap: "8px", flexShrink: 0 }}>
                  <button
                    onClick={() => handleComposeEmail(email.name, true)}
                    style={{
                      backgroundColor: selectedNumber === email.name ? "rgba(255,255,255,0.2)" : "#e3f2fd",
                      color: selectedNumber === email.name ? "white" : "#1976d2",
                      border: "none",
                      padding: "8px 12px",
                      borderRadius: "6px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      fontSize: "13px",
                      fontWeight: "600",
                      whiteSpace: "nowrap",
                      transition: "background-color 0.2s"
                    }}
                    title="Send Email"
                  >
                    <MdSend size={16} /> Send
                  </button>
                  <button
                    onClick={() => handleSelectEmail(email.name)}
                    style={{
                      backgroundColor: selectedNumber === email.name ? "rgba(255,255,255,0.9)" : "#fff",
                      color: selectedNumber === email.name ? "#007bff" : "#555",
                      border: selectedNumber === email.name ? "none" : "1px solid #ddd",
                      padding: "8px 12px",
                      borderRadius: "6px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      fontSize: "13px",
                      fontWeight: "600",
                      whiteSpace: "nowrap",
                      transition: "all 0.2s"
                    }}
                    title="Open Inbox"
                  >
                    <MdInbox size={18} /> Inbox
                  </button>
                </div>
              </li>
            ))}
          </ul>
          <button
            onClick={handleClose}
            className="modal_btn"
            onMouseOver={(e) =>
              (e.currentTarget.style.backgroundColor = "#0056b3")
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.backgroundColor = "#007bff")
            }
          >
            Close
          </button>
        </div>
      )}
    </Modal>
  );
}

export default Email_Select_Modal;
